(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SKIP = /header|announcement|menu-promo|np_head|np-head|cart-drawer|cart-notification|predictive-search/i;
  var CART_RE = /\/cart\/(add|change|update)/;

  /* ---------------- scroll reveal ---------------- */

  function autoTag() {
    if (!window.NP_ANIM_AUTO) return;
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.querySelector('[data-np-anim]')) return;
      if (s.id && SKIP.test(s.id)) return;
      var inner = s.firstElementChild;
      while (inner && (inner.tagName === 'STYLE' || inner.tagName === 'SCRIPT' || inner.tagName === 'LINK')) {
        inner = inner.nextElementSibling;
      }
      if (inner && !inner.hasAttribute('data-np-anim')) inner.setAttribute('data-np-anim', '');
    });
  }

  function prepare(section) {
    if (section.dataset.npAnimReady) return;
    section.dataset.npAnimReady = '1';
    section.classList.add('np-anim');

    var items = section.querySelectorAll('.np-anim-item');
    if (!items.length) {
      var host = section.querySelector('.np-wrap, .page-width, .np-pdp__grid') || section;
      Array.prototype.forEach.call(host.children, function (el) {
        if (el.tagName === 'STYLE' || el.tagName === 'SCRIPT' || el.tagName === 'LINK') return;
        el.classList.add('np-anim-item', 'np-anim-item--child');
      });
      items = section.querySelectorAll('.np-anim-item');
    }
    Array.prototype.forEach.call(items, function (el, i) {
      if (el.classList.contains('np-anim-item--child')) el.style.setProperty('--np-anim-index', i);
    });

    section.classList.add(reduce ? 'np-anim--shown' : 'np-anim--hidden');
  }

  function reveal(section) {
    section.classList.remove('np-anim--hidden');
    section.classList.add('np-anim--shown');
  }

  function init() {
    autoTag();
    var sections = document.querySelectorAll('[data-np-anim]');
    if (!sections.length) return;
    Array.prototype.forEach.call(sections, prepare);

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(sections, reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(sections, function (s) {
      if (!s.dataset.npAnimWatched) { s.dataset.npAnimWatched = '1'; io.observe(s); }
    });
  }

  /* ---------------- add to cart ---------------- */

  var SPINNER =
    '<div class="np-spinner" aria-hidden="true">' +
    '<svg focusable="false" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
    '<circle class="np-path" cx="33" cy="33" r="30"></circle></svg></div>';

  var pending = [];

  function ensureSpinner(btn) {
    if (!btn.querySelector('.np-spinner')) btn.insertAdjacentHTML('beforeend', SPINNER);
  }

  function start(btn) {
    ensureSpinner(btn);
    btn.classList.add('np-atc', 'np-is-loading');
    btn.setAttribute('aria-busy', 'true');
    // the reference disables only after the request is in flight
    setTimeout(function () { if (btn.classList.contains('np-is-loading')) btn.disabled = true; }, 0);
    if (pending.indexOf(btn) === -1) pending.push(btn);
  }

  // Two-stage exit, as the reference does it: label returns first,
  // then the disabled state (and its opacity) clears ~300ms later.
  function settle() {
    while (pending.length) {
      (function (btn) {
        btn.classList.remove('np-is-loading');
        btn.removeAttribute('aria-busy');
        setTimeout(function () { btn.disabled = false; }, 300);
      })(pending.pop());
    }
  }

  function watchCart() {
    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0];
        if (url && url.url) url = url.url;
        var isCart = typeof url === 'string' && CART_RE.test(url);
        var out = nativeFetch.apply(this, arguments);
        if (isCart) out.then(function (r) { setTimeout(settle, 120); return r; },
                             function (e) { settle(); throw e; });
        return out;
      };
    }

    var XHR = window.XMLHttpRequest;
    if (XHR && XHR.prototype.send) {
      var nativeOpen = XHR.prototype.open, nativeSend = XHR.prototype.send;
      XHR.prototype.open = function (m, u) {
        this.__npCart = typeof u === 'string' && CART_RE.test(u);
        return nativeOpen.apply(this, arguments);
      };
      XHR.prototype.send = function () {
        if (this.__npCart) this.addEventListener('loadend', function () { setTimeout(settle, 120); });
        return nativeSend.apply(this, arguments);
      };
    }
  }

  function wireAtc() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var btn = form.querySelector('[type="submit"], button[name="add"]');
      if (btn) start(btn);
      setTimeout(settle, 2500); // safety net
    }, true);

    ['cart:updated', 'cart-drawer:open', 'kaching:cart:open'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(settle, 120); });
    });
  }

  watchCart();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); wireAtc(); });
  } else {
    init(); wireAtc();
  }

  document.addEventListener('shopify:section:load', init);
  window.npAnimInit = init;
  window.npAtcStart = start;
  window.npAtcSettle = settle;
})();
